export default "__VITE_ASSET__BdiC2CvL__";